import { Directive, forwardRef, HostBinding, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
@Directive({
  host: {
    '[ngModel]': 'value',
    '(ngModelChange)': 'value = $event'
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OrchidFormControlDirective),
      multi: true
    }
  ],
  selector: '[odsFormControl]'
})
export class OrchidFormControlDirective implements ControlValueAccessor {
  @HostBinding('disabled') disabled = false;
  @HostBinding('value') value = '';
  @HostListener('change', ['$event.target.value']) _onChange(_value: string): void {}
  @HostListener('blur') _onTouched(_value: string): void {}
  registerOnChange(fn: (_value: string) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: (_value: string) => void): void {
    this._onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  writeValue(value: string): void {
    this.value = value;
  }
}